// WhatsApp click-to-chat links with a message pre-filled from the current page.

export const WHATSAPP_NUMBER = '34621058576';
export const PHONE_DISPLAY = '+34 621 05 85 76';
export const PHONE_HREF = '+34621058576';

type Locale = 'es' | 'en';

export type WhatsAppContext = {
  locale: Locale;
  /** Human topic inserted in the pre-filled message. */
  topic: string;
  /** Slug sent with the whatsapp_click event. */
  servicio: string;
};

type TopicRule = { test: RegExp; es: string; en: string; servicio: string };

// El orden importa: el pack antes que nómada/Beckham, la renovación de regularización antes que renovación genérica.
const TOPIC_RULES: TopicRule[] = [
  { test: /pack|package/, es: 'pack nómada digital + Ley Beckham', en: 'digital nomad + Beckham Law package', servicio: 'pack-nomada-digital-ley-beckham' },
  { test: /nomada|digital-nomad/, es: 'visado nómada digital', en: 'digital nomad visa', servicio: 'visado-nomada-digital' },
  { test: /beckham|impatriad|fiscalidad/, es: 'Ley Beckham', en: 'Beckham Law', servicio: 'ley-beckham' },
  { test: /no-lucrativ/, es: 'residencia no lucrativa', en: 'non-lucrative residence', servicio: 'residencia-no-lucrativa' },
  { test: /cualificad/, es: 'profesionales cualificados', en: 'highly qualified professionals', servicio: 'visado-para-profesionales-altamente-cualificados' },
  { test: /renovar-permiso-regularizacion/, es: 'renovación regularización', en: 'regularization permit renewal', servicio: 'renovacion-regularizacion' },
  { test: /renov/, es: 'renovación de residencia', en: 'residence renewal', servicio: 'renovacion-residencia' },
  { test: /nacionalidad|ciudadania/, es: 'nacionalidad española', en: 'Spanish nationality', servicio: 'nacionalidad-espanola' },
  { test: /arraigo/, es: 'arraigo', en: 'arraigo', servicio: 'arraigo' },
  { test: /estudi|student/, es: 'visado de estudios', en: 'student visa', servicio: 'residencia-por-estudios' },
];

export function getWhatsAppContext(pathname: string): WhatsAppContext {
  const path = (pathname || '/').toLowerCase();
  const locale: Locale = path === '/en' || path.startsWith('/en/') ? 'en' : 'es';
  const rule = TOPIC_RULES.find((item) => item.test.test(path));
  if (!rule) {
    return { locale, topic: locale === 'en' ? 'general enquiry' : 'consulta general', servicio: 'consulta-general' };
  }
  return { locale, topic: rule[locale], servicio: rule.servicio };
}

/** Pre-filled message; `refId` (e.g. ADS-NOMADA-7K2F) lets the firm tag the chat by source. */
export function buildWhatsAppMessage(context: Pick<WhatsAppContext, 'locale' | 'topic'>, refId?: string): string {
  const topic = context.topic.charAt(0).toUpperCase() + context.topic.slice(1);
  const message =
    context.locale === 'en'
      ? `Hi, I'm coming from your website (${topic}) and I'd like you to review my case.`
      : `Hola, vengo de la web (${topic}) y quiero que revisen mi caso.`;
  return refId ? `${message} Ref: ${refId}` : message;
}

export function buildWhatsAppUrl(message: string): string {
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
}
